import React, { Fragment } from "react";
import { RenderPrice, ToDateJalali } from "../../../../Common/Function";

function ClassInfo({ data }) {
  const handlerOffer = priiice => {
    const { price } = priiice;
    if (priiice.second_price) {
      let a = price - priiice.second_price;
      let x = (100 * a) / price;
      return (
        <label
          className="ClassLabel offerClassLabel m-2 "
          style={{ top: 0, left: "1px" }}
        >
          تخفیف {x} درصدی
        </label>
      );
    }
  };
  const handlerSex = sex => {
    switch (sex) {
      case "both":
        return "اقایان و بانوان";
      case "men":
        return "اقایان ";
      case "women":
        return "  بانوان";
    }
  };
  const handlerAgecategory = age => {
    switch (age) {
      case "child":
        return "کودکان";
      case "teen":
        return "نوجوانان";
      case "young":
        return "جوانان";
      case "adults":
        return "بزرگسالان";
    }
  };
  return (
    <div
      className="card cutumBorder cardSingle m-3 p-4"
      style={{
        backgroundColor: "#fff",
      }}
    >
      <div className="row justify-content-between align-items-center">
        <div className="col">
          <h3>{data && data.name} </h3>
        </div>
        <div className="col">{data && handlerOffer(data.price)}</div>
      </div>
      <hr />
      <div className="row">
        <div className="col">
          <div className="classInformation d-flex align-items-center">
            <span style={{ marginLeft: "5px" }}> نوع برگزاری :</span>
            <p>{data && data.type == "online" ? "مجازی" : "حضوری"}</p>
          </div>
          <div className="classInformation d-flex align-items-center">
            <span style={{ marginLeft: "5px" }}> جنسیت :</span>
            <p>{handlerSex(data && data.gender)}</p>
          </div>
          <div className="classInformation d-flex align-items-center">
            <span style={{ marginLeft: "5px" }}> رده سنی :</span>
            <p>
              {handlerAgecategory(
                data && data.description && data.description.agecatgegory
              )}{" "}
            </p>
          </div>
          <div className="classInformation d-flex align-items-center">
            <span style={{ marginLeft: "5px" }}> تعداد جلسات :</span>
            <p>{data && data.count_session} جلسه</p>
          </div>
          <div className="classInformation d-flex align-items-center">
            <span style={{ marginLeft: "5px" }}> ظرفیت باقی مانده :</span>
            <p>{data && data.capacity} نفر </p>
          </div>
          <div className="classInformation d-flex align-items-center">
            <span style={{ marginLeft: "5px" }}> تاریخ شروع کلاس :</span>
            <p>{ToDateJalali(data && data.start_date)} </p>
          </div>
          <div className="classInformation d-flex align-items-center">
            <span style={{ marginLeft: "5px" }}> اخرین مهلت ثبت نام :</span>
            <p>{ToDateJalali(data && data.exp_register)} </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClassInfo;
